<div class="flex flex-col sm:flex-row ssm:flex-row items-center md:items-start ssm:justify-center sm:justify-center md:justify-start flex-auto min-w-0 h-full login-page--background">
    <div class="md:flex md:justify-center md:items-center w-full ssm:w-auto md:h-full py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card bg-white ssm:rounded-2xl ssm:shadow flex-col relative container-mobile__setting">
        <div class="mips-login_footer flex flex-row gap-4 items-center absolute bottom-0 left-0 bg-slate-100 w-full justify-center">
            <div>
                <img src="../../../assets/images/logo/mips-logo-simple.png" alt="" class="mips-logo w-9">
            </div>
            <div class="font">
                For any queries reach out to MIPS 2.0 Team
            </div>
        </div>
        <div class="w-full max-w-80 sm:w-80 mx-auto ssm:w-80 text-center">
            <!-- Logo -->
            <div class="w-50 mx-auto">
                <img src="../../../assets/images/logo/Thorogood-main-logo.svg">
            </div>

            <!-- Title -->
            <div class="mt-8 text-2xl font uppercase">Sign In To MIPS 2.0</div>

            <!-- Microsoft sign-in button -->
            <button
                id="msalSignInButton"
                class="fuse-mat-button-large w-full mt-8 font login_button--design"
                mat-flat-button
                [disabled]="msalLoginInProgress"
                (click)="signInWithMicrosoft()">
                <div class="flex items-center justify-center">
                    <mat-icon class="icon-size-5 mr-2" svgIcon="microsoft-icon"></mat-icon>
                    <span *ngIf="!msalLoginInProgress">Sign in with Microsoft</span>
                    <mat-progress-spinner
                        *ngIf="msalLoginInProgress"
                        [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                </div>
            </button>
        </div>
    </div>
    <div class="relative hidden md:flex flex-auto items-center justify-center h-full p-16 lg:px-28 overflow-hidden dark:border-l">
    </div>
</div>
